



































import { Component, Vue, Watch } from 'vue-property-decorator';
import ComContainer from '@/components-business/common-container.vue';
import ComAlert from '@/components-business/common-alert.vue';
import { namespace } from 'vuex-class';
import FloatingWindow from '@/components-business/floating-window.vue';
import OverdueDialog from '@/components-business/overdue-dialog.vue';
import FreezeDialog from '@/components-business/freeze-dialog.vue';
import ClassWarnDialog from '@/components-business/class-warn-dialog.vue';
import NoviceDialog from '@/components-business/novice-dialog.vue';
import LessonDialog from '@/components-business/lesson-dialog.vue';
import CustomLecturesDialog from '@/components-business/custom-lectures-dialog.vue';
import SurveyBtn from '@/components-business/survey-btn.vue';
import RemoteLoginDialog from '@/components-business/remote-login-dialog.vue';
import utils from '@/utils';
import cookies from 'js-cookie';
import OptionsTab from './components/class-check.vue';

const userModule = namespace('user');

@Component({
  components: {
    ComContainer,
    ComAlert,
    FloatingWindow,
    OverdueDialog,
    FreezeDialog,
    ClassWarnDialog,
    NoviceDialog,
    OptionsTab,
    LessonDialog,
    CustomLecturesDialog,
    SurveyBtn,
    RemoteLoginDialog,
  },
})
export default class App extends Vue {
  @userModule.Getter('userInfo') userInfo: any

  @userModule.Getter('getRemoteLoginCount') remoteLoginCount!: number

  private remoteLoginDialogVisible: boolean = false;

  @Watch('remoteLoginCount', { immediate: true })
  onRemoteLoginCountChange(newVal: number) {
    this.checkAndShowRemoteLoginDialog();
  }

  private checkAndShowRemoteLoginDialog() {
    const count = this.remoteLoginCount || 0;
    if (count === 0) return;
    const userId = this.getUserId();
    if (utils.hasRemoteLoginDialogShownToday(userId)) {
      return;
    }
    this.remoteLoginDialogVisible = true;
  }

  private handleRemoteLoginDialogConfirm() {
    const userId = this.getUserId();
    utils.markRemoteLoginDialogShownToday(userId);
  }

  private getUserId() {
    return this.userInfo?.userId || cookies.get('userId') || '';
  }
}
